import React from 'react';
import { Link } from 'react-router-dom';

const logoSrc = `${process.env.PUBLIC_URL || ''}/logo.png`;

export default function BrandMark({
  to = '/',
  onClick,
  className = '',
  showName = true,
  size = 'md',
}) {
  const sizeClass = size === 'sm' ? 'brand-mark--sm' : size === 'lg' ? 'brand-mark--lg' : '';

  return (
    <Link
      to={to}
      className={`brand-mark ${sizeClass} ${className}`.trim()}
      onClick={onClick}
      aria-label="3AM AI home"
    >
      <img src={logoSrc} alt="" className="brand-mark__logo" width="36" height="36" />
      {showName && <span className="brand-mark__name">3AM AI</span>}
    </Link>
  );
}
